import { Link } from '@tanstack/react-router';

type BreadcrumbItem = {
	title: string;
	link?: string;
};

type Props = {
	items: Array<BreadcrumbItem>;
};

export default function Breadcrumbs({ items }: Props) {
	return (
		<nav aria-label="Breadcrumb">
			<ol
				itemScope
				itemType="https://schema.org/BreadcrumbList"
				className="inline-flex flex-wrap items-center gap-1"
			>
				{items.map((item, index) => {
					const isLast = index === items.length - 1;

					return (
						<li
							key={item.link ?? item.title}
							itemProp="itemListElement"
							itemScope
							itemType="https://schema.org/ListItem"
							className="breadcrumbs-item inline-flex items-center gap-1"
						>
							{!isLast && item.link ? (
								<Link
									to={item.link}
									itemProp="item"
									className="text-[var(--primary)] underline transition hover:brightness-80"
								>
									<span itemProp="name">{item.title}</span>
								</Link>
							) : (
								<span itemProp="name" aria-current="page" className="text-neutral-600">
									{item.title}
								</span>
							)}

							<meta itemProp="position" content={String(index + 1)} />
						</li>
					);
				})}
			</ol>
		</nav>
	);
}
